
























import { PropType, defineComponent, computed } from '@vue/composition-api';
import { Message, AutomationData } from '../../dataType';
import Card from './Card.vue';
// import { useAutomationConfig } from '../../hooks/useConfig';
import { useLocale } from '../../hooks/useLocale';
import { useAsideComponent } from '../../hooks/useAsideComponent';

export default defineComponent({
  components: {
    Card
  },
  props: {
    message: {
      type: Object as PropType<Message<AutomationData>>,
      required: true
    }
  },
  setup(props) {
    const { t } = useLocale();
    const { setAsideStatus, setAsideComponent, setRuleMessage } = useAsideComponent();
    const rule = computed(() => {
      return (props.message.content.rule || []);
    });
    const sourceTitle = computed(() => props.message.content.base.source);
    const title = computed(() => props.message.title);
    console.log(title, sourceTitle);
    // const { setAutomationProject, getAutomationProject } = useAutomationConfig();
    const clickOpenAutomation = async () => {
      setAsideStatus(true);
      setAsideComponent('AutomationModule');
      setRuleMessage(props.message);
      // message && addMessage(message);
    };
    return {
      t,
      rule,
      title,
      sourceTitle,
      clickOpenAutomation
    };
  }
});
